import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import {
  OpalApiComponent,
  OpalApiRequestBody,
  OpalApiResponseDocument,
} from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateCustomFieldV3'>['data']['attributes']
type RequestRelationships = OpalApiResponseDocument<
  'ReadCustomFieldV3',
  200
>['data']['relationships']

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'custom_field'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultCustomFieldAttributes: OptionalAttributes = {
  created_at: new Date().toISOString(),
  description: null,
  is_deactivated: false,
  updated_at: new Date().toISOString(),
  is_color_disabled: false,
  is_cascading: false,
  is_system_generated: false,
  default_notification_mode: 'manual',
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes & Partial<OptionalAttributes>
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'custom_field'> => {
  return {
    id: uuidv4(),
    type: 'custom_field',
    attributes: {
      ...defaultCustomFieldAttributes,
      ...attributes,
    },
    relationships: {
      ...relationships,
    },
    meta: {
      pending: true,
    },
  }
}
